<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1>Paramètres - Page de résultats</h1>
    </div>



  <b-col><!-- Result settings -->

    <b-row class="mt-3 pt-3">

      <!-- Texte de teasing pour obtenir tous les résultats (page info additionnelles) quand bons résultats -->
      <b-col md="2">
        <label>Texte "Bravo, obtenez vos résultats"</label>
      </b-col>
      <b-col md="10" class="mb-4">
        <b-form-textarea
          :value="settings.copy.additionnal_info_get_results_good | translategrader(lang)"
          placeholder="<p>Vous êtes très bon. Pour accéder à vos résultats détaillés, découvrir les bonnes pratiques associées et bénéficier de nos conseils, merci de bien vouloir remplir ce formulaire.</p>"
          @input="updateSettingsCopy($event, 'additionnal_info_get_results_good')"
          rows="3"
          max-rows="6">
        </b-form-textarea>
        <p class="text-info small mt-1">Paragraphe apparaissant sur la page de gating avant les résultats complets (score global >= 50). HTML possible</p>
      </b-col>

      <!-- Texte de teasing pour obtenir tous les résultats (page info additionnelles) quand mauvais résultats -->
      <b-col md="2">
        <label>Texte "C'est bof, obtenez vos résultats"</label>
      </b-col>
      <b-col md="10" class="mb-4">
        <b-form-textarea
          :value="settings.copy.additionnal_info_get_results_bad | translategrader(lang)"
          placeholder="<p>Vous pouvez vous améliorez. Pour accéder à vos résultats détaillés, découvrir les bonnes pratiques associées et bénéficier de nos conseils, merci de bien vouloir remplir ce formulaire.</p>"
          @input="updateSettingsCopy($event, 'additionnal_info_get_results_bad')"
          rows="3"
          max-rows="6">
        </b-form-textarea>
        <p class="text-info small mt-1">Paragraphe apparaissant sur la page de gating avant les résultats complets (score global < 50). HTML possible</p>
      </b-col>


      <!-- Bouton call page (stiky footer) -->
      <b-col md="2">
        <label for="call_back_text" >Texte bouton Call back <i class="fa fa-question-circle text-info" v-b-tooltip.hover title="Texte du bouton de callback en fin de diagnostic"></i></label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.expert_callback_text | translategrader(lang)"
          placeholder="Etre contacté par un expert"
          id="call_back_text"
          @input="updateSettingsCopy($event, 'expert_callback_text')">
        </b-form-input>
        <p class="text-info small mt-1">
        ex: https://www.okedito.com/expert_callback/?utm_source=autodiag&utm_medium=cta&utm_campaign=footer_resultat
        </p>
      </b-col>

      <!-- Bouton call page (stiky footer) -->
      <b-col md="2">
        <label for="setting_social_icons_share_linkedin" >Lien bouton Call back <i class="fa fa-question-circle text-info" v-b-tooltip.hover title="Lien vers la page de callback en fin de diagnostic"></i></label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.expert_callback_link | translategrader(lang)"
          placeholder="https://www.okedito.com/diagnostic-inbound-marketing/?utm_source=linkedin&utm_medium=social_share&utm_campaign=header_campaign_1"
          id="setting_social_icons_share_linkedin"
          @input="updateSettingsCopy($event, 'expert_callback_link')">
        </b-form-input>
        <p class="text-info small mt-1">
        ex: https://www.okedito.com/expert_callback/?utm_source=autodiag&utm_medium=cta&utm_campaign=footer_resultat
        </p>
      </b-col>

    </b-row>

  </b-col>

  </div>

</template>

<script>

  import { mapGetters, mapActions } from 'vuex';
  import { Photoshop } from 'vue-color'

  export default {

    name: 'admin_settings',

    data() {
      return {
        selectedLang: [], // Must be an array reference!
        optionsLang: [
          { text: 'Français', value: 'fr' },
          { text: 'English', value: 'en' },
          { text: 'Italiano', value: 'it' },
          { text: 'Deutsch', value: 'de' }
        ],
        checked: false,
        showingColorPicker: {'primary': false, 'secondary': false},
        tempColor: "#fff",
      }
    },

    components: {
      'photoshop-picker': Photoshop,
    },

    computed: {
      ...mapGetters('settings', {
        settings: 'settings',
        isSaving: 'isSaving'
      }),

      bgc_primary : function() {
        return {backgroundColor: this.settings.colors.primary};
      },

      bgc_secondary : function() {
        return {backgroundColor: this.settings.colors.secondary};
      },

      lang : function() {
        return this.$i18n.locale;
      },
    },

    async created() {
      await this.getOrCreateSetting();
      if (Array.isArray(this.settings.available_lang)) {
        this.selectedLang = this.settings.available_lang;
      }
    },

    methods: {
      ...mapActions({
        getOrCreateSetting: 'settings/getOrCreateSetting',
        saveSettings: 'settings/saveSettings'
      }),

      updateLanguages(event) {
        var tmpSettings = this.settings;
        tmpSettings.available_lang = event;
        this.saveSettings(tmpSettings);
      },

      updateSettingsCopy(value, targetKey) {
        // Saving title in current language
        var tmpSettings = this.settings;
        if (typeof this.$i18n.locale === "undefined") {
          tmpSettings.copy[targetKey] = value;
          // we might need to cover multi-> single languages at some point
          // (or just fallback "en" or "fr" by default)
        }
        else {
          if (typeof tmpSettings.copy[targetKey] !== 'undefined' && tmpSettings.copy[targetKey].constructor == Object) {
            // If we already have a lang dict
            tmpSettings.copy[targetKey][this.$i18n.locale] = value;
          } else {
            // else we have a non-multiligual string. We need to erase it first
            var newSettings = tmpSettings.copy;
            delete newSettings[targetKey];
            newSettings[targetKey] = {};
            newSettings[targetKey][this.$i18n.locale] = value;
          }
        }
        this.saveSettings(tmpSettings);
      },

      updateSettingsForms(value, targetKey) {
        // Saving title in current language
        var tmpSettings = this.settings;
        if (typeof this.$i18n.locale === "undefined") {
          tmpSettings.forms[targetKey] = value;
          // we might need to cover multi-> single languages at some point
          // (or just fallback "en" or "fr" by default)
        }
        else {
          if (typeof tmpSettings.forms[targetKey] !== 'undefined' && tmpSettings.forms[targetKey].constructor == Object) {
            // If we already have a lang dict
            tmpSettings.forms[targetKey][this.$i18n.locale] = value;
          } else {
            // else we have a non-multiligual string. We need to erase it first
            var newSettings = tmpSettings.forms;
            delete newSettings[targetKey];
            newSettings[targetKey] = {};
            newSettings[targetKey][this.$i18n.locale] = value;
          }
        }
        this.saveSettings(tmpSettings);
      },
    },

  }
</script>



<style scoped>
h2 {
  color: #005E88;
}

.colorDemo {
  float: right;
  width: 15px;
  height: 15px;
  border: 1px solid #DDD;
  background-color: #0000F2;
}

.demo-img {
  background: #eee;
  padding: 20px;
}

.spinnerSave {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.vc-photoshop {
  position: absolute;
  right: 0px;
  top: 50px;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/settings/AdminSettingsResultsPage.vue